import { InsightDTO } from '../../shared/types';
import { BaseGateway, QueryRequestOptions } from '../BaseGateway';
import { GatewayName } from '../types';

export class AnalyticsGateway extends BaseGateway {
  name: GatewayName = 'analytics';

  async getInsights(options?: QueryRequestOptions): Promise<{ items: InsightDTO[] }> {
    const { data } = await this.httpGet('/v1/insights', options);
    return { ...data, items: data.insights };
  }

  async getInsight(
    id: string,
    query?: {
      prefersDark?: boolean;
      theme?: Record<string, string>;
    },
    options?: QueryRequestOptions,
  ): Promise<{ insight: InsightDTO; embedUrl?: string }> {
    const theme = query?.theme ? btoa(JSON.stringify(query.theme)) : undefined;

    const params = {
      prefersDark: query?.prefersDark,
      theme,
    };
    const { data } = await this.httpGet(`/v1/insights/${id}`, { params, ...options });
    const { omniEmbedUrl, ...rest } = data;
    return { ...rest, embedUrl: omniEmbedUrl };
  }
}
